export enum CUSTOMER_CARE_ACTION_PERMISSIONS {
  VIEW = 'CUSTOMERCAREACTION_VIEW',
  WRITE = 'CUSTOMERCAREACTION_WRITE',
}
